import type Quill from 'quill/core';
import type { Range } from 'quill/core';
import { isCellManager } from '../../editor/formats/utils/CellManager';
import type Mark from '../../editor/utils/Mark';

const getMarkForMagneticWallItem = (quill: Quill, range: Range): Mark => {
  if (range.length <= 1) {
    const [leaf] = quill.getLeaf(range.index);
    if (leaf && isCellManager(leaf)) {
      const identity = leaf.getActiveCellIdentity();
      if (identity) {
        const rangeInCell = leaf.getCellLastRange(identity);
        if (rangeInCell) {
          return {
            type: 'cell',
            index: range.index,
            cell: { identity, ...rangeInCell },
          };
        }
      }
      // @ts-expect-error
    } else if (leaf?.statics.blotName === 'code-embed' && !leaf.isPreviewing) {
      // @ts-expect-error
      const codeRange = leaf.getLastRange();
      if (codeRange) {
        return {
          type: 'code',
          index: range.index,
          code: codeRange,
        };
      }
    }
  }

  return { type: 'plain', ...range };
};

export default getMarkForMagneticWallItem;
